import React, { FC, PropsWithChildren } from "react";
import { Jumbotron } from "reactstrap";
import { Footer } from "components/Footer/footer";
import { BaseLayout } from "layouts/BaseLayout";

interface LayoutProps {
    pageType?: string;
    canonicalUrl?: string;
    isJumbotronContentOverlay?: boolean;
    jumboTronSubTitle?: string;
    jumboTronTitle?: string;
    jumbotronType?: "home" | "notfound";
    metaDescription?: string;
    noContainer?: boolean;
    pageName?: string;
    socialMediaImage?: string;
    title?: string;
    footerMiddleSection?: JSX.Element;
}

export const Layout: FC<PropsWithChildren<LayoutProps>> = ({
    jumbotronType,
    noContainer,
    isJumbotronContentOverlay,
    jumboTronTitle,
    jumboTronSubTitle,
    footerMiddleSection,
    children,
    ...rest
}) => {
    const isJumbotronPage = typeof jumbotronType === "string";
    const container = noContainer ? "" : "container pt-3";
    const mainClassName =
        isJumbotronPage && isJumbotronContentOverlay
            ? `${container} jumbotron-content-for-overlay`
            : container;
    const jumbotronClassName = isJumbotronContentOverlay
        ? "jumbotron--content-overlay p-4 pt-3 mb-4"
        : "";

    return (
        <BaseLayout {...rest} jumbotronPage={isJumbotronPage}>
            {isJumbotronPage && (
                <Jumbotron
                    className={`jumbotron jumbotron--feature jumbotron--${jumbotronType} ${jumbotronClassName} hidden-sm-down`}
                >
                    {jumboTronTitle && (
                        <h1 className="jumbotron__title display-1 text-center m-y-md">
                            {jumboTronTitle}
                            <br />
                            {jumboTronSubTitle}
                        </h1>
                    )}
                </Jumbotron>
            )}
            <div className={`main ${mainClassName}`}>{children}</div>
            <Footer middleSection={footerMiddleSection} />
        </BaseLayout>
    );
};
